import { memo, useMemo } from 'react';
import { State, useSelector } from '@betty/toolkit/state';
import { selectCategory } from '../../state';
import { CategoryDetailsProps } from './CategoryDetails.types';
import GamesGrid from '../GamesGrid/GamesGrid';
import EmptyCategoryMessage from '../GamesGrid/EmptyCategoryMessage/EmptyCategoryMessage';

function CategoryDetails({ id }: CategoryDetailsProps) {
  const category = useSelector((state: State) => selectCategory(state, id));
  const gameIds = useMemo(
    () => category?.games.map((game) => game.id),
    [category],
  );
  const isFavoriteCateogry = category?.gamesSelectionType === 'Favorites';

  return (
    <GamesGrid
      gameIds={gameIds ?? []}
      loading={!gameIds?.length && !isFavoriteCateogry}
      contentContainerStyle={{
        paddingTop: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        paddingHorizontal: 'space-600',
      }}
      imageType="square"
      ListEmptyComponent={EmptyCategoryMessage}
    />
  );
}

export default memo(CategoryDetails);
